/**
 * Powermail date fields: native `<input type="date">` with invisible
 * `::-webkit-calendar-picker-indicator` (see _form.scss). Clicks on the text
 * area then need `showPicker()` — but `pointerdown` + `click` both calling it
 * breaks Firefox (picker flashes closed). Only `click` is safe across engines.
 */
function openNativePicker(input) {
  if (typeof input.showPicker === 'function') {
    try {
      input.showPicker();
    } catch {
      /* Safari / strict contexts may throw */
    }
    return;
  }
  input.focus();
  input.click();
}

export function initPowermailDatePicker() {
  const inputs = document.querySelectorAll('input.powermail_date');
  if (!inputs.length) return;

  inputs.forEach((input) => {
    input.addEventListener('click', (event) => {
      if (event && 'isTrusted' in event && event.isTrusted === false) return;
      openNativePicker(input);
    });
  });
}
